import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "800",
  height: "800",
  viewBox: "0 0 48 48",
  xmlns: "http://www.w3.org/2000/svg"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g data-name=\"Layer 2\"><path fill=\"none\" d=\"M0 0h48v48H0z\" data-name=\"invisible box\"></path><g data-name=\"icons Q2\"><path d=\"M24 8a19 19 0 1 0 19 19A19 19 0 0 0 24 8Zm0 34a15 15 0 1 1 15-15 15 15 0 0 1-15 15ZM7.2 11.6l8-6a2 2 0 0 0 .4-2.8 2 2 0 0 0-2.8-.4l-8 6a2 2 0 0 0-.4 2.8A2.1 2.1 0 0 0 6 12a1.9 1.9 0 0 0 1.2-.4ZM43.2 8.4l-8-6a2 2 0 0 0-2.8.4 2 2 0 0 0 .4 2.8l8 6a1.9 1.9 0 0 0 1.2.4 2.1 2.1 0 0 0 1.6-.8 2 2 0 0 0-.4-2.8Z\"></path><path d=\"M31 25h-5v-5a2 2 0 0 0-4 0v5h-5a2 2 0 0 0 0 4h5v5a2 2 0 0 0 4 0v-5h5a2 2 0 0 0 0-4Z\"></path></g></g>", 1)
  ]))]))
}
export default { render };